import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

function ContentAclEdit({curAcl, onUpdate}) {

	const [acl,setAcl] = React.useState(curAcl);

	function handlePasswordChange(e) {
		console.log("handlePasswordChange: password = " + e.target.value);
		let cv = e.target.value;

		let updatedAcl = {
			password: cv
		};
		setAcl(updatedAcl);

		if (onUpdate) {
			onUpdate(updatedAcl);
		}
	}

	function handleKeyPress(e) {
		//console.log("handleKeyPress");
/*
		if (e.key === 'Enter') {
			if (onUpdate) {
				onUpdate(acl);
			}
			e.preventDefault();
		}
*/
	}

	return (
		<>
			<Typography
				sx={{
					fontFamily: '노토산스 Bold',
					fontSize: `${14/360 * 100}vw`,
					color: '#171717',
					width: '100%',
					marginTop: `${25/360 * 100}vw`,
				}}
			>
				비밀번호
			</Typography>
			<TextField
				sx={{
					marginTop: `${20/360 * 100}vw`,
					width: `${320/360 * 100}vw`,
					//height: `${43/360 * 100}vw`,
				}}
				variant="outlined"
				type="text"
				value={acl ? acl.password : ""}
				onChange={handlePasswordChange}
				onKeyPress={handleKeyPress}
			/>
			<Box
				display="flex"
				flexDirection="row"
				justifyContent="flex-start"
				alignItems="flex-start"
				sx={{
					marginTop: `${10.5/360 * 100}vw`,
					width: '100%',
					height: `${24/360 * 100}vw`,
				}}
			>
				<img
					src="icons/drawable-xhdpi/설정_아이콘.png"
					style={{
						width:`${14/360 * 100}vw`,
						height:`${14/360 * 100}vw`,
						marginRight:`${10/360 * 100}vw`
					}}
					alt='exclamation mark'
				/>
				<Box
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="flex-start"
					sx={{
						width: '100%',
						height: `${24/360 * 100}vw`,
					}}
				>
					<Typography
						sx={{
							fontFamily: '노토산스 Regular',
							fontSize: `${10/360 * 100}vw`,
							color: '#aeaeae',
							width: '100%',
						}}
					>
						설정시 비밀번호 확인 후 콘텐츠 확인이 가능합니다.
					</Typography>
					<Typography
						sx={{
							fontFamily: '노토산스 Regular',
							fontSize: `${10/360 * 100}vw`,
							color: '#aeaeae',
							width: '100%',
						}}
					>
						영문 또는 숫자를 사용하여 20자 이내로 설정해 주세요.
					</Typography>
				</Box>
			</Box>
		</>
	);
}

export default ContentAclEdit;
